export default __webpack_public_path__ + "static/media/book.6f8b1a36.gif";